import { createFileRoute, Link } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/checkout_/return")({
  head: () =>
    seoHead({
      path: "/checkout/return",
      title: "Order Confirmed — Coffman Cove Lodging Shop",
      description:
        "Your Coffman Cove Lodging shop order is confirmed. We pack and ship straight to your door in the lower 48.",
      extraMeta: [{ name: "robots", content: "noindex, nofollow" }],
    }),
  validateSearch: (search: Record<string, unknown>): { order?: string; stay?: string } => ({
    order: typeof search['order'] === "string" ? search['order'] : undefined,
    stay: typeof search['stay'] === "string" ? search['stay'] : undefined,
  }),
  component: CheckoutReturn,
});

function CheckoutReturn() {
  const { order, stay } = Route.useSearch();
  const isStay = stay === "1";
  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-20 text-center">
      <p className="text-[10px] uppercase tracking-[0.3em] text-[var(--color-ember)]">
        Payment complete
      </p>
      <h1 className="mt-3 font-display text-4xl">Thanks — you're all set.</h1>
      <p className="mt-4 text-muted-foreground">
        {order && !isStay && (
          <>
            Your order number is{" "}
            <span className="font-mono text-foreground">
              {order.slice(0, 8).toUpperCase()}
            </span>
            .{" "}
          </>
        )}
        {isStay
          ? "Your stay is paid in full — rooms, boats and extras. We'll email your receipt, and you can check the details any time on My stay."
          : "We'll email your receipt, pack the order at the lodge, and ship it to your door in the lower 48."}
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to={isStay ? "/my-stay" : "/shop"}
          className="rounded-md bg-[var(--color-ember)] px-6 py-3 text-sm font-semibold uppercase tracking-wider text-[var(--color-ember-foreground)] hover:opacity-90"
        >
          {isStay ? "Back to my stay" : "Back to the shop"}
        </Link>
        <Link
          to="/contact"
          className="rounded-md border border-border px-6 py-3 text-sm font-semibold uppercase tracking-wider hover:border-[var(--color-ember)] hover:text-[var(--color-ember)]"
        >
          Contact the lodge
        </Link>
      </div>
    </div>
  );
}
